<script setup>

import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import {computed, onMounted, reactive, watch} from "vue";
import favoritesApi from "@/Api/favorites-api";
import {useToast} from "vue-toastification";

const toast = useToast();

const props = defineProps({
    item: {
        type: Object,
        required: true,
    },
    hasLoaded: {
        type: Boolean,
        required: false,
        default: false,
    },
    isFavorite: {
        type: Boolean,
        required: false,
        default: false,
    },
    size: {
        type: String,
        required: false,
        default: null,
    },
});

const localItem = reactive({
    value: props.item,  // Initialize with the prop value
})

const data = reactive({
    isFavorite: false,
})

onMounted(() => {
    data.isFavorite = props.isFavorite;
})

watch(() => props.item, (newValue) => {
    localItem.value = newValue;
}, { deep: true });

watch(() => props.isFavorite, (newValue) => {
    data.isFavorite = newValue;
}, { deep: true });

function handleFavoriteClick(item) {
    if (!props.hasLoaded) {
        return;
    }
    if (data.isFavorite) {
        unfavoriteItem(localItem.value)
    } else {
        favoriteItem(localItem.value)
    }
}

function favoriteItem(item) {
    localItem.value.favorites_count = localItem.value.favorites_count + 1
    data.isFavorite = true
    postFavoriteCreatureRequest(item.id)
}

function unfavoriteItem(item) {
    localItem.value.favorites_count = Math.max(0, localItem.value.favorites_count - 1);
    data.isFavorite = false
    postUnfavoriteCreatureRequest(item.id)
}

const determineIcon = computed(() => {
    return data.isFavorite ? ['fas', 'heart'] : ['far', 'heart'];
});

const iconClass = computed(() => {
    if (!props.hasLoaded) {
        return 'ml-2 text-gray-400 cursor-not-allowed pointer-events-none';
    }
    return 'ml-2 text-blue-600 cursor-pointer';
});

function postFavoriteCreatureRequest(creatureId) {
    console.log("post favorite creature request")
    const request = { creature_id: creatureId }
    favoritesApi.postFavoriteCreature(request).then(response => {
        console.log(response.data)
    }).catch(function (error) {
        const message = error.response?.data?.message ?? "Something went wrong. Please try again.";
        toast.error(message);
    });
}

function postUnfavoriteCreatureRequest(creatureId) {
    console.log("post unfavorite creature request")
    const request = { creature_id: creatureId }
    favoritesApi.deleteFavoriteCreature(request).then(response => {
        console.log(response.data)
    }).catch(function (error) {
        const message = error.response?.data?.message ?? "Something went wrong. Please try again.";
        toast.error(message);
    });
}

</script>

<template>
    <div class="flex items-center">
        <div v-if="data.isFavorite !== null" class="flex items-center">
            <FontAwesomeIcon
                :icon="determineIcon"
                :class="iconClass"
                :size="props.size"
                @click="handleFavoriteClick(item)"
            />
            <p v-if="localItem.value.favorites_count > 0" class="ml-1 text-xs text-gray-400">{{ localItem.value.favorites_count }}</p>
        </div>
    </div>
</template>

<style scoped>

</style>
